import { RemoteGetAllUsersMetrics } from 'data/usecases';
import { GetAllUsersMetrics } from 'domain/usecases';
import { makeApiUrlUsersMetrics } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetAllUsersMetrics = (): GetAllUsersMetrics =>
  new RemoteGetAllUsersMetrics(makeApiUrlUsersMetrics(), makeAxiosHttpClient());
